<template>
  <v-menu
    v-bind="field"
    :close-on-content-click="true"
    :nudge-right="25"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="localDate"
        :disabled="disabled || readOnly"
        :label="label"
        :rules="allRules"
        @blur="blur"
        v-on="on"
        prepend-icon="mdi-calendar"
      />
    </template>
    <v-date-picker
      v-bind="field"
      v-if="!disabled"
      v-model="date"
      :landscape="true"
      :min="watchedValue || '1970-01-01'"
      @change="updateValue"
    />
  </v-menu>
</template>

<script>

export default {
  name: 'DateField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    watchedValue: {
      required: false,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      date: this.toEdit && this.checkDate(this.toEdit.substr(0, 10)) ? this.toEdit.substr(0, 10) : undefined
    }
  },
  computed: {
    allRules () {
      const isDate = value => this.checkLocalDate(value) ? true : 'Dit is geen geldige datum'
      const isAfterWatchedDate = value => this.checkDateRange(this.parseDate(value), this.watchedValue) ? true : 'Deze datum ligt vóór de startdatum'
      return [...this.rules, isDate, isAfterWatchedDate]
    },
    localDate: {
      get () {
        return this.formatDate(this.date)
      },
      set (newDate) {
        return this.parseDate(newDate)
      }
    }
  },
  watch: {
    toEdit () {
      if (this.checkDate(this.toEdit)) {
        this.date = this.toEdit ? this.toEdit.substr(0, 10) : undefined
      }
    }
  },
  methods: {
    checkDate (date) {
      if (date === undefined || date === '') { return true }
      if (typeof date !== 'string') { return false }
      return /^\d\d\d\d-\d\d-\d\d/.test(date)
    },
    checkLocalDate (date) {
      if (date === undefined || date === '') { return true }
      if (typeof date !== 'string') { return false }
      return /^\d\d-\d\d-\d\d\d\d$/.test(date)
    },
    checkDateRange (date, startDate) {
      if (!startDate || !date) { return true }
      return new Date(startDate.substr(0, 10)) <= new Date(date.substr(0, 10))
    },
    formatDate (date) {
      if (!date) { return '' }
      const [year, month, day] = date.split('-')
      if (day === undefined || month === undefined || year === undefined) { return '' }
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    parseDate (date) {
      if (!date) { return '' }
      const [day, month, year] = date.split('-')
      if (day === undefined || month === undefined || year === undefined) { return '' }
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    blur (event) {
      this.$emit('update:toEdit', this.parseDate(event.target.value))
    },
    updateValue (date) {
      this.$emit('update:toEdit', date)
    }
  }
}
</script>

<style scoped>
  .v-input {
    padding-top: 0;
  }
</style>
